import React from 'react';
import { PATHS } from 'src/common/constants';
import Anchor from 'src/components/Anchor';
import Auth from 'src/layouts/Auth/Auth';
import Button from 'src/components/Button';
import Loader from 'src/components/Loader';
import NewPasswordFields from 'src/components/NewPasswordFields';
import { Images } from 'src/Tenants';
import LinkValidation from 'src/pages/LinkValidation/LinkValidation';
import {
  useLinkBasedPasswordFlow,
  UseLinkBasedPasswordFlowReturn,
} from 'src/SharedCustomHooks/UseLinkBasedPasswordFlow/useLinkBasedPasswordFlow';

const ResetPassword = () => {
  const {
    linkStatus,
    password,
    confirmPassword,
    requirements,
    passwordsMismatch,
    canSubmit,
    isSubmitting,
    updatePassword,
    updateConfirmPassword,
    submit,
  }: UseLinkBasedPasswordFlowReturn = useLinkBasedPasswordFlow('Reset Password');

  if (linkStatus.kind === 'validating') {
    return <Loader center={true} />;
  }

  if (linkStatus.kind === 'invalid') {
    return <LinkValidation message={linkStatus.message} />;
  }

  const onSubmit = (e: React.FormEvent): void => {
    e.preventDefault();
    void submit();
  };

  return (
    <Auth
      title="Reset Password"
      backgroundImage={Images.signInImage}
      content={
        <div className="sign-in">
          <form onSubmit={onSubmit}>
            <div className="sign-in-header">
              <div className="sign-in-headline">Reset Password</div>
            </div>

            <NewPasswordFields
              password={password}
              confirmPassword={confirmPassword}
              onPasswordChange={updatePassword}
              onConfirmPasswordChange={updateConfirmPassword}
              requirements={requirements}
              passwordsMismatch={passwordsMismatch}
              passwordLabel="Password"
            />
            {isSubmitting ? <Loader center={true} /> : null}
            <div className="sign-in-button">
              <Button
                label="Reset Password"
                color="teal"
                submit
                block
                disabled={!canSubmit || isSubmitting}
              />
            </div>
            <div className="sign-in-footer">
              Remember your password?{' '}
              <Anchor path={PATHS.AUTH_SIGN_IN} label="Sign In" />
            </div>
          </form>
        </div>
      }
    />
  );
};

export default ResetPassword;
